import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=5b1f4a3c&"
import script from "./Notification.vue?vue&type=script&lang=js&"
export * from "./Notification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\wamp\\www\\laravel\\rawal\\rawal-laravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b1f4a3c')) {
      api.createRecord('5b1f4a3c', component.options)
    } else {
      api.reload('5b1f4a3c', component.options)
    }
    module.hot.accept("./Notification.vue?vue&type=template&id=5b1f4a3c&", function () {
      api.rerender('5b1f4a3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/settings/Notification.vue"
export default component.exports